module.exports = __webpack_public_path__ + "img/SI2013649.f6b24c9c.svg";